import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import directives from "./directives";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import axiosconfigurator from "@/global/config/axiosconfiguartor";
import VuetifyConfirm from "vuetify-confirm";
import VueScrollactive from "vue-scrollactive";
import Notifications from "vue-notification";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import i18n from "./translations";

Vue.use(VueAxios, axios);
Vue.use(directives);
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(VueScrollactive);
Vue.use(Notifications);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.config.productionTip = false;

/* Config Axios */
const apiUrl = process.env.VUE_APP_API_URL;
axiosconfigurator.initialization({
  baseURL: apiUrl,
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
